import React from 'react';
import { useTranslation } from '@wix/yoshi-flow-editor';
import {
  SectionNotification,
  SectionNotificationType,
  TextButton,
} from 'wix-ui-tpa/cssVars';
import { useFormActions } from '../../Hooks/useFormActions';
import { classes } from './LoginBar.st.css';
import { LoginBarDataHooks } from './dataHooks';

export interface LoginBarProps {
  isLoggedIn: boolean;
  email?: string;
}

const LoginBar: React.FC<LoginBarProps> = ({ isLoggedIn, email }) => {
  const { t } = useTranslation();
  const { promptLogin, logout } = useFormActions();

  return (
    <div className={classes.root}>
      <SectionNotification
        data-hook={LoginBarDataHooks.ROOT}
        type={SectionNotificationType.wired}
        size="regular"
      >
        <SectionNotification.Text data-hook={LoginBarDataHooks.TEXT}>
          {isLoggedIn ? (
            t('app.bookings-form.login-bar.logged-in', { email })
          ) : (
            <>
              {t('app.bookings-form.login-bar.logged-out')}
              <TextButton
                data-hook={LoginBarDataHooks.LOGIN_BUTTON}
                className={classes.button}
                onClick={() => promptLogin({ dialog: 'site-default' })}
              >
                {t('app.bookings-form.login-bar.login')}
              </TextButton>
            </>
          )}
        </SectionNotification.Text>
        {isLoggedIn && (
          <TextButton
            data-hook={LoginBarDataHooks.LOGOUT_BUTTON}
            className={classes.button}
            onClick={logout}
          >
            {t('app.bookings-form.login-bar.logout')}
          </TextButton>
        )}
      </SectionNotification>
    </div>
  );
};

export default LoginBar;
